var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"my-5"},[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v(" 指定されたURLは見つかりませんでした。 ")]),_c('p',[_c('router-link',{staticClass:"link",attrs:{"to":"/"}},[_vm._v("イントロダクションへ")]),_c('router-link',{staticClass:"link",attrs:{"to":"/app"}},[_vm._v("アプリケーションへ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }